import { Dispatch } from "@reduxjs/toolkit";
import { openDeleteCardModal } from "@tvg/sh-lib-paws/redux/slices/deleteCardModalSlice";
import { gtmDeletePaymentMethodButton } from "../../gtm";
import { PaymentTypeOption } from "../../types";

export const onDelete =
  (dispatch: Dispatch, paymentMethod: PaymentTypeOption) => () => {
    gtmDeletePaymentMethodButton({ paymentType: paymentMethod.paymentType });
    dispatch(openDeleteCardModal(paymentMethod));
  };
